import { InputHTMLAttributes } from 'react';

type Props = {
  isSingleSymbol?: boolean;
  isInvalid: boolean;
  error: string;
} & InputHTMLAttributes<HTMLInputElement>;

const Input = ({ isSingleSymbol, isInvalid, error, ...props }: Props) => (
  <div className='relative'>
    {isInvalid && <div className='text-main-red-900 absolute text-xxs top-[-20px] w-full'>{error}</div>}
    <input
      {...props}
      className={`appearance-none 
    block w-full 
    p-4
    rounded-md 
    placeholder-main-gray-900 
    focus:outline-none 
    bg-main-grey-500 
    text-lg
    ${isSingleSymbol ? 'text-center' : ''}
    ${isInvalid ? `bg-main-red-500 text-main-red-900` : ''}
    `}
    />
  </div>
);

export { Input };
